import { fork } from 'redux-saga/effects';

import GoldGateway from '~apis/gold';
import ApprovalGateway from '~apis/approval';
import DiscountGateway from '~apis/discount';
import CustomerGateway from '~apis/customer';
import BranchGateway from '~apis/branch';
import CustomerTransferGateway from '~apis/customerTransfer';
import { RootSagaReturnType } from '~types/saga';

import watchGetPendingTransactionListing from './getPendingTransactionListing';
import watchUpdateTransactionStatus from './updateTransactionStatus';
import watchGetPendingInventoryTransactionListing from './getPendingInventoryTransactionListing';
import watchUpdateInventoryTransactionStatus from './updateInventoryTransactionStatus';
import watchGetPendingDiscountListing from './getPendingDiscountListing';
import watchUpdateDiscountStatus from './updateDiscountStatus';
import watchUpdateProductStatus from './updateProductStatus';
import watchGetPendingCollateralListing from './getPendingCollateralListing';
import watchUpdateCollateralStatus from './updateCollateralStatus';
import watchUpdateProjectStatus from './updateProjectStatus';
import watchGetPendingInventoryTransferListing from './getPendingInventoryTransferListing';
import watchUpdateTransferStatus from './updateInventoryTransferStatus';
import watchGetPendingReleaseEarmarkListing from './getPendingReleaseEarmarkListing';
import watchUpdateReleaseEarmarkStatus from './updateReleaseEarmarkStatus';
import watchGetPendingBranchesListing from './getPendingBranchesListing';
import watchUpdateBranchStatus from './updateBranchStatus';
import watchGetPendingGoldConversionListing from './getPendingConversionListing';
import watchUpdateGoldConversionStatus from './updateGoldConversionStatus';
import watchUpdateEarmarkConversionStatus from './updateEarmarkConversionStatus';
import watchGetPendingStockOutListing from './getPendingStockOutListing';
import watchUpdateStockOutStatus from './updateStockOutStatus';
import watchGetPendingCustomerTransferListing from './getPendingCustomerTransferListing';
import watchUpdateCustomerTransferStatus from './updateCustomerTransferStatus';

export default (approvalApi: ApprovalGateway, goldApi: GoldGateway, discountApi: DiscountGateway, customerApi: CustomerGateway, branchApi: BranchGateway, customerTransferApi: CustomerTransferGateway,): RootSagaReturnType => {
    function* rootSaga() {
        yield fork(watchUpdateTransactionStatus, approvalApi);
        yield fork(watchUpdateInventoryTransactionStatus, approvalApi);
        yield fork(watchUpdateDiscountStatus, approvalApi);
        yield fork(watchUpdateProductStatus, approvalApi);
        yield fork(watchUpdateCollateralStatus, approvalApi);
        yield fork(watchUpdateProjectStatus, approvalApi);
        yield fork(watchUpdateTransferStatus, approvalApi);
        yield fork(watchUpdateReleaseEarmarkStatus, approvalApi);
        yield fork(watchUpdateBranchStatus, approvalApi);
        yield fork(watchUpdateGoldConversionStatus, approvalApi);
        yield fork(watchUpdateStockOutStatus, approvalApi);
        yield fork(watchUpdateCustomerTransferStatus, approvalApi);

        yield fork(watchGetPendingTransactionListing, goldApi);
        yield fork(watchGetPendingInventoryTransactionListing, goldApi);
        yield fork(watchGetPendingInventoryTransferListing, goldApi);
        yield fork(watchGetPendingGoldConversionListing, goldApi);
        yield fork(watchGetPendingDiscountListing, discountApi);
        yield fork(watchGetPendingCollateralListing, customerApi);
        yield fork(watchGetPendingReleaseEarmarkListing, customerApi);
        yield fork(watchGetPendingBranchesListing, branchApi);
        yield fork(watchUpdateEarmarkConversionStatus, approvalApi);
        yield fork(watchGetPendingStockOutListing, goldApi);
        yield fork(watchGetPendingCustomerTransferListing, customerTransferApi);
    }

    return {
        rootSaga,
    };
};
